import React, {ReactNode} from 'react'

import {Button} from '@daedalus/atlas/Button'
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper'
import {Flex} from '@daedalus/atlas/helpers/Flex'
import {Grid} from '@daedalus/atlas/helpers/Grid'
import {useBrand} from '@daedalus/core/src/_web/brand/hooks/useBrand'
import {bookingErrorMessages} from '@daedalus/core/src/booking/messages'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import {DateAndRoomsText} from '../../search/DateAndRoomsText'
import {ErrorMessagesLayout} from './ErrorMessagesLayout'

interface PropsType {
  checkIn: string
  checkOut: string
  rooms: string
  onClick: () => void
  redirectOffersSlot: ReactNode
  hotelCardSlot: ReactNode
}

export const SoldOutErrorContentLayout = ({
  checkIn,
  checkOut,
  rooms,
  onClick = () => {},
  redirectOffersSlot,
  hotelCardSlot
}: PropsType) => {
  const {brand} = useBrand()

  return (
    <ContentWrapper padding="s500">
      <Grid gap="s500">
        <ErrorMessagesLayout
          titleSlot={
            <FormattedMessageWrapper
              {...bookingErrorMessages.soldOutTitle}
              values={{brandName: brand.name}}
            />
          }
          descriptionSlot={
            <FormattedMessageWrapper
              {...bookingErrorMessages.soldOutDescription}
            />
          }
        />

        <Flex.Column justifyContent="center" alignItems="center">
          <DateAndRoomsText
            checkIn={checkIn}
            checkOut={checkOut}
            rooms={rooms}
            hasCustomStyle
          />
        </Flex.Column>
        <ContentWrapper paddingTop="s400" paddingBottom="s600">
          {hotelCardSlot}
          {redirectOffersSlot}
        </ContentWrapper>
      </Grid>

      <Button fullWidth variant="secondary" onClick={onClick} size="xl">
        <FormattedMessageWrapper
          id="chooseAnotherProperty"
          defaultMessage="Back to property"
        />
      </Button>
    </ContentWrapper>
  )
}
